import { Injectable } from '@angular/core';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  titulo: any;
  texto: any;
  imgTop: any;
  imgClass: any;
  animacion: any;
  startAnimateRangeNumber: number = 1;
  endAnimateRangeNumber: number = 4505683;
  durationAnimateRangeNumber: number = 50;
  isLoadingDarkWeb: boolean = false;
  current: any;
  stopAnimateRangeNum: boolean = false;

  constructor() {$('#loaderMicro').hide(); }

  close() {
    // tslint:disable-next-line: only-arrow-functions
    setTimeout(function () {
      $('#loader').modal('hide');
      // this.texto = '';
      // this.titulo = '';
      // this.imgTop = '';
      // this.imgClass = '';
      // this.animacion = false;
      // $('#loaderAnimation').html('');
    }, 1000);
  }

  open() {    
    $('#loader').modal({ backdrop: 'static', keyboard: false });
  }

  animateRangeNumber(start:any, end:any, duration:any) {
    const range = end - start;
    this.current = start;
    const increment = end > start ? 2200 : -2200;
    const stepTime = Math.abs(Math.floor(duration / range));
    const obj = $('elementAnimateRangeNumber');
    const model = this;
    model.stopAnimateRangeNum = false;
    const timer = setInterval(function () {
      if (obj) {
        model.current += increment;
        if (model.current > end || model.stopAnimateRangeNum) {
          model.current = end;
          clearInterval(timer);
        }
      }
    }, stepTime);
  }

  closeMicro() {
      $('#loaderMicro').hide();
  }

  openMicro() {    
    $('#loaderMicro').show();
  }
}
